module.exports = __webpack_public_path__ + "img/IMG_3119_L_BlackMatted_MockedUp.57526984.jpg";